module.exports = __webpack_public_path__ + "img/checked-black.d9c25250.svg";